import { ScrollView, Text } from 'react-native'

export default function Page() {
  return (
    <ScrollView contentInsetAdjustmentBehavior="automatic">
      <Text>停用查询</Text>
    </ScrollView>
  )
}
